"use strict";import{tag as c}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const MoreIcon=({width:e=24,height:r=24,hidden:t=!1,title:l="More"}={})=>c`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${e}
    height=${r}
    viewBox="0 0 36 36"
    aria-hidden=${t?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${l}
  >
    <circle cx="17.8" cy="18.2" r="3.4" />
    <circle cx="29.5" cy="18.2" r="3.4" />
    <circle cx="6.1" cy="18.2" r="3.4" />
  </svg>`;
//# sourceMappingURL=More.js.map
